var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isLoaded)?_c('RouterView',{attrs:{"default-reports":_vm.listOfReports,"custom-reports":_vm.mappedCustomReportsList},on:{"refresh":_vm.loadCustomReports}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }